module.exports = __webpack_public_path__ + "static/media/nf.9c35f8b0.svg";